import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import {
  BrandAdminProvider,
  useBrandAdmin,
} from '../contexts/BrandAdminContext';
import { SelectDropdown } from './ui';

const BrandAdminHeader: React.FC = () => {
  const { linkedBrands, selectedBrand, setSelectedBrand, isLoading } =
    useBrandAdmin();
  const options = linkedBrands.map(brand => ({
    label: brand.name,
    value: brand.id,
  }));

  const handleBrandChange = (value: string) => {
    const brand = linkedBrands.find(b => b.id === value);
    if (brand) {
      setSelectedBrand(brand);
    }
  };

  if (isLoading) {
    return (
      <div className="flex justify-between px-6 xl:px-16 py-4">
        <h1 className="heading-3-bold">Loading...</h1>
      </div>
    );
  }

  return (
    <div className="flex justify-between px-6 xl:px-16 py-4">
      <h1 className="heading-3-bold">
        {selectedBrand?.name || 'No Brand Selected'}
      </h1>
      <SelectDropdown
        options={options}
        value={selectedBrand?.id || ''}
        onChange={handleBrandChange}
        className="border border-gray-200 rounded-md bg-white w-[360px]"
      />
    </div>
  );
};

const BrandAdminLayout: React.FC = () => {
  const location = useLocation();
  
  // Only show header for these exact routes
  const showHeader = 
    location.pathname === '/brand-admin/brand-dashboard' ||
    location.pathname === '/brand-admin/brand-hotels' ||
    location.pathname === '/brand-admin/reporting';

  return (
    <BrandAdminProvider>
      <div
        className="flex flex-col min-h-[var(--spacing-screen-height)]"
        style={{
          background:
            'linear-gradient(180deg, #DDF0FF -40.45%, #F4F8FA 79.49%)',
        }}
      >
        {showHeader && <BrandAdminHeader />}
        <Outlet />
      </div>
    </BrandAdminProvider>
  );
};

export default BrandAdminLayout;
